module.exports = __webpack_public_path__ + "static/img/banner2_2.7381dc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner2_2.jpg
// module id = NQY/
// module chunks = 0